import React, { useState, useEffect } from "react";
import { Container, Nav, Navbar } from "react-bootstrap";
import { motion } from "framer-motion";
import { Link } from "react-scroll"; // Use Link from react-scroll
import "aos/dist/aos.css";
import AOS from "aos";
import "./Navtab.css";
import logo from "../../assets/projectimg/mylogo.png"
function Navtab() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [expanded, setExpanded] = useState(false); // State to control navbar expand/collapse

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 70);
    };

    window.addEventListener("scroll", handleScroll);

    AOS.init({ duration: 800, once: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <Navbar
        collapseOnSelect
        expand="lg"
        className={`navbar-custom ${isScrolled ? "scrolled" : ""}`}
        data-aos="fade-down"
        expanded={expanded} // Bind navbar to expanded state
      >
        <Container>
          <Navbar.Brand as={Link} to="home" className="navbar-logo">
            <img src={logo} alt="Logo" className="logo" />
          </Navbar.Brand>
          <Navbar.Toggle
            aria-controls="responsive-navbar-nav"
            onClick={() => setExpanded(expanded ? false : true)} //
          />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="ms-auto ">
              <Nav.Link
                as={Link}
                to="home"
                smooth
                duration={500}
                className="nav-link-custom fs-5"
                onClick={() => setExpanded(false)} // Close navbar after clicking
              >
                Home
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="interest"
                smooth
                duration={500}
                className="nav-link-custom fs-5"
                onClick={() => setExpanded(false)}
              >
                Interest
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="project"
                smooth
                duration={500}
                className="nav-link-custom fs-5"
                onClick={() => setExpanded(false)}
              >
                Projects
              </Nav.Link>
            </Nav>
            <Nav>
              <Nav.Link
                as={Link}
                to="contact"
                smooth
                duration={500}
                className="contact-me-button fs-5"
                onClick={() => setExpanded(false)}
              >
                Contact Me
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </motion.div>
  );
}

export default Navtab;
